/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUser } from './ApiUser';
import {
    ApiUserFromJSON,
    ApiUserFromJSONTyped,
    ApiUserToJSON,
    ApiUserToJSONTyped,
} from './ApiUser';

/**
 * 
 * @export
 * @interface ApiNote
 */
export interface ApiNote {
    /**
     * 
     * @type {number}
     * @memberof ApiNote
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiNote
     */
    content: string;
    /**
     * 
     * @type {ApiUser}
     * @memberof ApiNote
     */
    user?: ApiUser;
    /**
     * 
     * @type {Date}
     * @memberof ApiNote
     */
    createdTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof ApiNote
     */
    alertId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiNote
     */
    sanctionAlertId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiNote
     */
    bridgeAlertId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiNote
     */
    statusChangeId?: number;
}

/**
 * Check if a given object implements the ApiNote interface.
 */
export function instanceOfApiNote(value: object): value is ApiNote {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ApiNoteFromJSON(json: any): ApiNote {
    return ApiNoteFromJSONTyped(json, false);
}

export function ApiNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiNote {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'content': json['content'],
        'user': json['user'] == null ? undefined : ApiUserFromJSON(json['user']),
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
        'alertId': json['alertId'] == null ? undefined : json['alertId'],
        'sanctionAlertId': json['sanctionAlertId'] == null ? undefined : json['sanctionAlertId'],
        'bridgeAlertId': json['bridgeAlertId'] == null ? undefined : json['bridgeAlertId'],
        'statusChangeId': json['statusChangeId'] == null ? undefined : json['statusChangeId'],
    };
}

export function ApiNoteToJSON(json: any): ApiNote {
    return ApiNoteToJSONTyped(json, false);
}

export function ApiNoteToJSONTyped(value?: ApiNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'content': value['content'],
        'user': ApiUserToJSON(value['user']),
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
        'alertId': value['alertId'],
        'sanctionAlertId': value['sanctionAlertId'],
        'bridgeAlertId': value['bridgeAlertId'],
        'statusChangeId': value['statusChangeId'],
    };
}

